import { Component, Input } from '@angular/core';
import { AppointmentInventory } from 'src/app/core/models/appointment-inventory.model';

@Component({
	selector: 'app-inventory-modal-header',
	templateUrl: './inventory-modal-header.component.html',
	styleUrls: ['./inventory-modal-header.component.scss']
})
export class InventoryModalHeaderComponent {

	@Input()
	inventoryItem: AppointmentInventory;

}
